<button class="e-close-icon" aria-label="Close shares grid changes dialog" (click)="onCancel()">
  <span class="fas fa-times"></span>
</button>
<div class="e-dialog-icon">
  <span class="fas fa-exclamation-triangle e-warning"></span>
</div>
<h2 class="e-prompt-title">{{ data.title }}</h2>

<div class="e-prompt-options">
  <button class="e-prompt-option" (click)="onProceed()">
    <div class="e-prompt-arrow" aria-hidden="true"><span class="fa-arrow-alt-circle-right fas"></span></div>
    <div class="e-prompt-option-content">
      <p class="e-prompt-option-title">{{ data.proceedText }}</p>
      <p class="e-prompt-option-description">{{ data.proceedDescription }}</p>
    </div>
  </button>
</div>

<div class="e-prompt-options">
  <button class="e-prompt-option" (click)="onCancel()">
    <div class="e-prompt-arrow" aria-hidden="true"><span class="fa-arrow-alt-circle-right fas"></span></div>
    <div class="e-prompt-option-content">
      <p class="e-prompt-option-title">{{ data.cancelText }}</p>
      <p class="e-prompt-option-description">{{ data.cancelDescription }}</p>
    </div>
  </button>
</div>